import { render, staticRenderFns } from "./patientOcr.vue?vue&type=template&id=3c478f90&"
import script from "./patientOcr.vue?vue&type=script&lang=js&"
export * from "./patientOcr.vue?vue&type=script&lang=js&"
import style0 from "./patientOcr.vue?vue&type=style&index=0&id=3c478f90&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports